export default "/assets/images/problem-solved-02.bdbf3dbac13947fe.webp";